module.exports = __webpack_public_path__ + "static/media/pic6.3f2e4d46.jpg";